module.exports = __webpack_public_path__ + "img/SJ.8c5d9101.png";